import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
  styled,
} from '@mui/material';
import { ReactNode } from 'react';

const StyledDialog = styled(Dialog)(({ theme: { palette } }) => ({
  '& .MuiDialog-paper': {
    borderLeft: '9px solid',
    borderColor: palette.primary.main,
    padding: '16px 8px 16px 8px',
  },
  borderRadius: '16px',
  padding: '20px',
}));

const StyledDialogTitle = styled(DialogTitle)(({ theme: { palette } }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  lineHeight: '22px',
  fontSize: '20px',
  letterSpacing: '0.15px',
  color: palette.text.primary,
}));

const StyledDialogContent = styled(DialogContent)({
  display: 'flex',
});

const StyledDialogContentText = styled(DialogContentText)(({ theme: { palette } }) => ({
  fontSize: '17px',
  lineHeight: '20px',
  letterSpacing: '0.15px',
  color: palette.text.primary,
}));

export type BaseDialogProps = DialogProps & {
  title: string;
  subtitle?: string | ReactNode;
  children?: ReactNode;
  dialogActions?: ReactNode;
  leftAdornment?: ReactNode;
};

export function BaseDialog({
  title,
  subtitle,
  children,
  dialogActions,
  leftAdornment,
  ...dialogProps
}: BaseDialogProps) {
  return (
    <StyledDialog fullWidth {...dialogProps}>
      <StyledDialogTitle>
        {leftAdornment}
        {title}
      </StyledDialogTitle>

      <StyledDialogContent>
        {subtitle && <StyledDialogContentText>{subtitle}</StyledDialogContentText>}
        {children}
      </StyledDialogContent>

      {dialogActions && <DialogActions>{dialogActions}</DialogActions>}
    </StyledDialog>
  );
}
